import { useLocation, useNavigate, useResolvedPath } from 'react-router-dom';
import Tab from './Tab';
import { Text } from 'theme-ui';
import { titleize } from 'inflected';
import Flex from './Flex';

export default function NavTab({ title = null, path, children = null, icon: Icon = null, ...props }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { pathname: resolvedPath } = useResolvedPath(path);

  return (
    <Tab
      className="nav-tab"
      isActive={pathname.startsWith(resolvedPath)}
      onClick={() => navigate(path)}
      {...props}
    >
      {children || (
        <Flex inline alignItems="center">
          <Text sx={{ mr: Icon ? 1 : undefined}}>{title || titleize(path)}</Text>
          {Icon && <Icon />}
        </Flex>
      )}
    </Tab>

  );
}
